import React from "react";
import { ButtonResolver } from "../../Element";

export const HeaderButtonSignup = () => (
  <ButtonResolver resolve="signup" $square>
    sign up
  </ButtonResolver>
);
